export default "__VITE_ASSET__L9L2B3M93qNjV$H4xjuYrA__"